import React, { useState } from 'react';
/** lib **/
import classNames from 'classnames';
/** style,images **/
import s from '../../styles/molecules/faq-item.module.scss';
import { ReactComponent as ArrowTop } from 'assets/images/arrow-top.svg';

type Props = {
  className?: string;
  question: string;
  answer: string;
  isBlack?: boolean;
};
export const FaqItem: React.FC<Props> = ({ className, question, answer, isBlack = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classNames(className, s.faqItemWrapper, isOpen ? s.isOpen : ``, isBlack ? s.isBlack : ``)} onClick={() => setIsOpen(!isOpen)}>
      <div className={s.question}>
        <p><span className={s.questionMark}>Q.</span> <span className={s.questionText}>{question}</span></p>
        <ArrowTop className={s.icon} />
      </div>
      <div className={classNames(s.answer, isOpen ? s.isOpen : ``)}>{answer}</div>
    </div>
  );
};
